import { FaBookmark } from "react-icons/fa6";
import trainingImage from "../../assets/training-image.webp";
import "./training-details-module.css";

export default function TrainingDetailsModule({ training }: any) {
  const currentColor = "#5d8d78";
  return (
    <div className="ae-training-details-container -light-theme -fade-in">
      <div className="ae-training-details-content-container" id={training.url}>
        <p>{training.paragraph}</p>
        <img className="ae-training-details-image" src={trainingImage} alt=""/>
        {training.subcategories &&
          training.subcategories.map((subcategory: any) => (
            <div
              className="ae-training-details-subcategory"
              key={subcategory.title}
            >
              <h2 className="ae-training-details-title">
                <FaBookmark fill={currentColor} /> {subcategory.title}
              </h2>
              <p className="ae-training-details-subtitle">
                {subcategory.subtitle}
              </p>
              <p>
                {subcategory.paragraph}
              </p>
            </div>
          ))}
      </div>
    </div>
  );
}
